import { notifications } from '@mantine/notifications';

/**
 * Rückmeldung nach einer Ticket-Änderung — mit dem Unterschied, auf den es ankommt:
 * Ist Weclapp nicht erreichbar (Ausfall oder Sperre), antwortet der Server mit
 * `pending: true`. Die Änderung ist dann im Portal gespeichert und sofort sichtbar, steht
 * aber noch nicht in Weclapp; ein Job trägt sie nach.
 *
 * Zentral, damit die Unterscheidung nicht an jeder Aufrufstelle neu getroffen werden muss:
 * Ein grünes „Ticket aktualisiert" über einer wartenden Änderung ist die eine Auskunft, die
 * der Techniker später nicht mehr nachprüfen kann.
 */
export function showTicketUpdateNotice(
  result: { pending?: boolean; message?: string } | undefined | null,
  successTitle = 'Ticket aktualisiert',
  successMessage = '',
  /**
   * Text für den Wartefall, wenn „Änderung" nicht passt. Ein Kommentar wird nicht
   * „übertragen, sobald weclapp antwortet" — er erreicht bis dahin niemanden, und das
   * gehört dazugesagt.
   */
  pendingMessage?: string,
): void {
  if (result?.pending) {
    notifications.show({
      title: 'Im Portal gespeichert — Weclapp folgt',
      message:
        result.message ??
        pendingMessage ??
        'Weclapp ist derzeit nicht erreichbar. Die Änderung wird automatisch übertragen, sobald es wieder antwortet.',
      color: 'yellow',
      // Länger als der Standard: Diese Meldung ist eine Information, keine Bestätigung.
      autoClose: 9000,
    });
    return;
  }
  notifications.show({ title: successTitle, message: successMessage, color: 'green' });
}
